import React from 'react';
import styled from 'styled-components';

const FAQs = () => {
  return (
    <Wrapper>
      <div className="content-box">
        <h2>FAQs</h2>

        <h4>Is BakPoket free to use?</h4>
        <p>
          Yes! Browsing coupons, deals, and offers is completely free for all users. Merchants can also register and upload offers — basic listings are free, and we offer optional paid slots for better visibility.
        </p>

        <h4>How can I register on BakPoket?</h4>
        <ul>
          <li>Click on “Register” on the top right corner.</li>
          <li>Select <strong>User</strong> if you want to browse and save offers.</li>
          <li>Select <strong>Merchant</strong> if you want to promote your offers.</li>
          <li>Fill in the required details and verify your email — that’s it!</li>
        </ul>

        <h4>I’m a Merchant. How can I upload my offer or ad post?</h4>
        <p>After registering and logging in:</p>
        <ul>
          <li>Go to your Merchant Dashboard.</li>
          <li>Click <strong>Upload Offer</strong>.</li>
          <li>Fill in the offer details, upload images, and choose your display slot.</li>
          <li>Submit for Admin approval — once approved, it will go live.</li>
        </ul>

        <h4>What are Ad Slots, and how do they work?</h4>
        <p>Ad Slots are special spots on the homepage or featured sections where your offers get extra visibility. Merchants can:</p>
        <ul>
          <li>Choose free randomized slots</li>
          <li>Or purchase premium slots for guaranteed placement and positioning.</li>
        </ul>

        <h4>How long will my offer be visible?</h4>
        <p>Each offer stays active until its expiry date, which you set while uploading. Expired offers are automatically removed from public display.</p>

        <h4>Can I edit or delete my uploaded offer?</h4>
        <p>Yes. Just log into your Merchant Dashboard:</p>
        <ul>
          <li>Go to <strong>My Offers</strong></li>
          <li>Click <strong>Edit</strong> or <strong>Delete</strong> next to the offer you want to manage.</li>
        </ul>

        <h4>How are offers approved?</h4>
        <p>All offers go through a quick admin review process to ensure:</p>
        <ul>
          <li>Content is relevant and non-offensive</li>
          <li>No fake or misleading promotions</li>
          <li>Once approved, they go live almost instantly.</li>
        </ul>

        <h4>Do you support regional languages for offers?</h4>
        <p>Yes, merchants can upload content in English, Hindi, or Telugu. Our platform is built for a multilingual audience.</p>

        <h4>How can I contact BakPoket support?</h4>
        <p>
          You can reach us through:
          <ul>
            <li>Contact Us page on the website</li>
            <li>Or email us at <a href="mailto:support@bakpoket.com">support@bakpoket.com</a></li>
          </ul>
        </p>

        <h4>Is my personal data safe on BakPoket?</h4>
        <p>Absolutely. We use industry-standard encryption and privacy protocols to ensure your data is safe and never sold to third parties.</p>

        <h4>Do I need to install any app?</h4>
        <p>Nope! BakPoket is fully responsive and works on mobile, tablet, and desktop browsers. Just visit bakpoket.com — no app needed.</p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: #e6e6e6;
  padding: 40px 16px;
  display: flex;
  justify-content: center;

  .content-box {
    width: 100%;
    max-width: 1200px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 10px;
    line-height: 1.7;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
  }

  h2 {
    margin-bottom: 20px;
    font-size: 2rem;
    font-weight: 600;
  }

  h4 {
    margin-top: 30px;
    margin-bottom: 10px;
    color: #444;
    font-size: 1.2rem;
  }

  ul {
    margin-left: 20px;
    padding-left: 20px;
    list-style: disc;
  }

  li {
    margin-bottom: 10px;
  }

  a {
    color: #ef4766;
    text-decoration: none;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    .content-box {
      padding: 25px;
      font-size: 0.95rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h4 {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 16px 40px;
    .content-box {
      padding: 20px;
      font-size: 0.9rem;
    }

    h2 {
      font-size: 1.3rem;
    }

    h4 {
      font-size: 1rem;
    }

    ul {
      margin-left: 15px;
    }
  }
`;

export default FAQs;
